package com.arenaproplay.admin.ui.utils

import com.arenaproplay.admin.domain.admin.Period
import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

/**
 * Keeps list-page state (page, query, period…) in the query string so
 * refresh, back/forward and shared links land on the same view.
 * `replaceState` is used on purpose: typing in a search box must not
 * pollute browser history with one entry per keystroke.
 */
fun urlParam(name: String): String? =
    URLSearchParams(window.location.search).get(name)?.takeIf { it.isNotBlank() }

fun periodFromUrl(name: String = "period"): Period? =
    Period.entries.find { it.code == urlParam(name) }

/** Null or blank value removes the parameter. */
fun setUrlParams(vararg params: Pair<String, String?>) {
    val search = URLSearchParams(window.location.search)
    params.forEach { (key, value) ->
        if (value.isNullOrBlank()) search.delete(key) else search.set(key, value)
    }
    val qs = search.toString()
    val newUrl = window.location.pathname +
        (if (qs.isEmpty()) "" else "?$qs") +
        window.location.hash
    window.history.replaceState(null, "", newUrl)
}
